import Vue from "vue";

Vue.component("document-symbols", {
	props: ["domain", "notificationFormatId", "output", "isReadOnly", "label", "excluded", "multipleTags", "isRevision"],
	data() {
		return {
			options: [],
			renderedItems: [],
			placeholder: htmlEntity.decode(window.labels.selectSymbol),
			noItemMessage: htmlEntity.decode(window.labels.thereAreNoItems),
			timeoutId: '',
			hasCounter: false
		};
	},
	computed: {
		computedValue: {
			get() {
				const text = this.output;
				if (!text) return [];
				return this.output.split("|");
			},
			set(value) {
				if (value) {
					this.$emit("update:output", value.join("|"));
				} else {
					this.$emit("update:output", []);
				}
			}
		}
	},
	methods: {
		getSymbolsForTagInput: function (text) {
			this.$services.symbols.getForTagInput({
				domain: this.domain,
				notificationFormatId: this.notificationFormatId,
				searchTerm: text,
				excludedNotificationFormatIds: this.excluded,
				isRevision: this.isRevision ? this.isRevision : false
			})
				.then((data) => {
					this.options = data.items.map(t => t.text);
					if (!this.options || this.options.length <= 0) {
						this.noItemMessage = htmlEntity.decode(window.labels.thereAreNoItems);
					}
				});
		},
		getFilteredItems(text) {
			this.options = [];
			this.noItemMessage = htmlEntity.decode(window.labels.searching) + "...";
			if (this.timeoutId) clearTimeout(this.timeoutId);
			this.timeoutId = setTimeout(() => {
				this.getSymbolsForTagInput(text);
			}, 500);
		},
		getDataSourceMultiText: (value) => {
			if (value) {
				var returnValue = "";
				const items = value.split("|");
				items.forEach(function (item) {
					returnValue += `${item}; `;
				});
				returnValue = !returnValue ? "" : returnValue.substr(0, returnValue.length - 2);
				return returnValue;
			}
			return "";
		},
		onBeforeAdding(tagToAdd) {
			if(this.options) {
				return this.options.includes(tagToAdd);
			}

			return false;
		},
	},
	template: `
		<b-field :label="label | decodeHTMLEntity">
		<b-taginput
			class="input original-symbol"
			v-if="!isReadOnly"
			v-model="computedValue"
			:data="options"
			:maxtags="multipleTags ? 1000 : 1"
			:has-counter="hasCounter"
			autocomplete
			ref="taginput"
			icon="label"
			:allow-new="false"
			:allow-duplicates="false"
			:before-adding="onBeforeAdding"
			:placeholder="placeholder"
			@typing="getFilteredItems">				
				<template #empty>{{ noItemMessage }}</template>
				<template #selected="props">
                    <b-tag v-for="(item, index) in props.selectItems" 
						   :key="index" 
						   rounded 
						   :tabstop="false" 
						   ellipsis 
						   closable 
						   @close="$refs.taginput.removeTag(index, $event)"
					>
                        {{item}}
                    </b-tag>
                </template>
			</b-taginput>
			<div v-if="isReadOnly" class="input">{{ getDataSourceMultiText(output) }}</div>
		</b-field>
	`
});